export default __webpack_public_path__ + "static/media/logoEdited.907d4a3b.png";